import styled from 'styled-components';
import { useCameraViewContext } from '../../context';
import { Icon } from '@material-ui/core';
import { QuizIcon } from 'pages/ListerVehicleUploadV2/icons/quizIcon';
import { useTakeNextHandler } from '../takeNext';

const Wrapper = styled.div`
  padding: 0px 16px;
`;

const StyledButton = styled.div`
  border-radius: 6px;
  width: 100%;
  background: #3994de;
  display: flex;
  gap: 6px;
  align-items: center;
  justify-content: center;
  height: 44px;
  box-shadow: 0px 4px 4px 0px #00000040;
`;

const StyledLabel = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  line-height: 14.06px;
  text-decoration-line: underline;
`;

export const OpenQuestionsButton = () => {
  const { openConfirmDialog } = useCameraViewContext();
  const saveImage = useTakeNextHandler({ switchToCameraView: false });
  const handleClick = async () => {
    const response = await saveImage();
    if (response && response.loading) return;
    openConfirmDialog();
  };

  return (
    <Wrapper>
      <StyledButton onClick={handleClick}>
        <Icon>
          <QuizIcon />
        </Icon>
        <StyledLabel>Proceed to Questions</StyledLabel>
      </StyledButton>
    </Wrapper>
  );
};
